export const replaceColorName = (from:string, to:string, colors:{[key:string]: string}): {[key:string]: string} => {
  const newColors = Object.keys(colors).reduce((map, key) => {
    const newKey = key.replace(from, to);
    map = {...map, [newKey]:colors[key]};
    return map;
  }, {});
  
  return newColors;
};
  